import { combineReducers } from 'redux';

import {
    SET_REQUEST_ID,
    SET_MERCHANT_TRANSACTION_ID,
    REQUEST_COFIDIS_ELIGIBILITY,
    SUCCESS_COFIDIS_ELIGIBILITY,
    FAILURE_COFIDIS_ELIGIBILITY,
    REQUEST_COFIDIS_INITIALIZE,
    SUCCESS_COFIDIS_INITIALIZE,
    FAILURE_COFIDIS_INITIALIZE,
    REQUEST_COFIDIS_CONFIRM,
    SUCCESS_COFIDIS_CONFIRM,
    FAILURE_COFIDIS_CONFIRM
} from './constants';

const requestId = (state = null, action) => {
    switch (action.type) {
        case SET_REQUEST_ID:
            return action.requestId;
        default:
            return state;
    }
};

const merchantTransactionId = (state = null, action) => {
    switch (action.type) {
        case SET_MERCHANT_TRANSACTION_ID:
            return action.merchantTransactionId;
        default:
            return state;
    }
};

const eligible = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_COFIDIS_ELIGIBILITY:
            return action.response.payload.eligible;
        case REQUEST_COFIDIS_ELIGIBILITY:
        case FAILURE_COFIDIS_ELIGIBILITY:
            return false;
        default:
            return state;
    }
};

const fetchingEligibility = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COFIDIS_ELIGIBILITY:
            return true;
        case FAILURE_COFIDIS_ELIGIBILITY:
        case SUCCESS_COFIDIS_ELIGIBILITY:
            return false;
        default:
            return state;
    }
};

const errorEligibility = (state = '', action) => {
    switch (action.type) {
        case FAILURE_COFIDIS_ELIGIBILITY:
            return action.response.message;
        case REQUEST_COFIDIS_ELIGIBILITY:
        case SUCCESS_COFIDIS_ELIGIBILITY:
            return '';
        default:
            return state;
    }
};

const initialize = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_COFIDIS_INITIALIZE:
            return action.response.payload.sessionToken;
        case REQUEST_COFIDIS_INITIALIZE:
        case FAILURE_COFIDIS_INITIALIZE:
            return false;
        default:
            return state;
    }
};

const fetchingInitialize = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COFIDIS_INITIALIZE:
            return true;
        case FAILURE_COFIDIS_INITIALIZE:
        case SUCCESS_COFIDIS_INITIALIZE:
            return false;
        default:
            return state;
    }
};

const errorInitialize = (state = '', action) => {
    switch (action.type) {
        case FAILURE_COFIDIS_INITIALIZE:
            return action.response.message;
        case REQUEST_COFIDIS_INITIALIZE:
        case SUCCESS_COFIDIS_INITIALIZE:
            return '';
        default:
            return state;
    }
};

const confirm = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_COFIDIS_CONFIRM:
            return action.response.payload.confirmed;
        case REQUEST_COFIDIS_CONFIRM:
        case FAILURE_COFIDIS_CONFIRM:
            return false;
        default:
            return state;
    }
};

const fetchingConfirm = (state = false, action) => {
    switch (action.type) {
        case REQUEST_COFIDIS_CONFIRM:
            return true;
        case FAILURE_COFIDIS_CONFIRM:
        case SUCCESS_COFIDIS_CONFIRM:
            return false;
        default:
            return state;
    }
};

const errorConfirm = (state = '', action) => {
    switch (action.type) {
        case FAILURE_COFIDIS_CONFIRM:
            return action.response.message;
        case REQUEST_COFIDIS_CONFIRM:
        case SUCCESS_COFIDIS_CONFIRM:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    requestId,
    merchantTransactionId,
    eligible,
    fetchingEligibility,
    errorEligibility,
    initialize,
    fetchingInitialize,
    errorInitialize,
    confirm,
    fetchingConfirm,
    errorConfirm
});



// WEBPACK FOOTER //
// ./src/services/cofidis/reducer.js